import * as React from 'react';
import { Button, Modal, ModalFooter, ModalHeader, ModalBody } from 'reactstrap';

export interface GuestsProps {
    onSelectGuests: any;
}

export interface ListItems {
    itemValue: string;
    itemText: string;
}

export default class AdditionalRegistrants extends React.PureComponent<GuestsProps> {

    state = {
        ddlState: [],
        Registrantmodal: false,
        DeleteModal: false,
        AddTitle: {},
        UpdateTitle: { display: 'none' },
        Registrants_arr: [],
        GuestIdMax: 0,
        GuestRowIndex: '',
        GuestFName: '',
        GuestLName: '',
        GuestEmail: '',
        GuestAddress1: '',
        GuestCity: '',
        GuestZipCode: '',
        GuestAddress2: '',
        GuestState: '',
        GuestType: '',
        lblResult: ''
    };
    constructor(props: any) {
        super(props);

        fetch('api/ListItems/State')
            .then(response => response.json() as Promise<Array<ListItems[]>>)
            .then(list => {
                this.setState({ ddlState: list });
            }).catch(error => {
                console.log(error);
            });

        this.Add = this.Add.bind(this);
        this.toggle = this.toggle.bind(this);
        this.ShowRegistrantModal = this.ShowRegistrantModal.bind(this);
        this.CloseDeleteModal = this.CloseDeleteModal.bind(this);
        this.CloseRegistrantModal = this.CloseRegistrantModal.bind(this);
        this.Clear = this.Clear.bind(this);
        this.FillForm = this.FillForm.bind(this);
        this.Edit = this.Edit.bind(this);
        this.DeleteGuest = this.DeleteGuest.bind(this);
    }

    ShowRegistrantModal() {
        this.setState({ Registrantmodal: !this.state.Registrantmodal });
        this.setState(() => ({ AddTitle: { display: 'flex' } }));
        this.setState(() => ({ UpdateTitle: { display: 'none' } }));
    }

    toggle() {
        this.setState({
            Registrantmodal: !this.state.Registrantmodal
        });
    }
    CloseDeleteModal() {
        this.setState({
            DeleteModal: !this.state.DeleteModal
        });
    }

    CloseRegistrantModal() {
        this.Clear();
        this.setState({
            Registrantmodal: !this.state.Registrantmodal
        });
    }

    Clear() {
        this.setState({ GuestFName: '' });
        this.setState({ GuestLName: '' });
        this.setState({ GuestEmail: '' });
        this.setState({ GuestAddress1: '' });
        this.setState({ GuestCity: '' });
        this.setState({ GuestZipCode: '' });
        this.setState({ GuestAddress2: '' });
        this.setState({ GuestState: '' });
        this.setState({ GuestType: '' });
        this.setState({ lblResult: '' });
        this.setState({ GuestRowIndex: '' });
    }

    Add() {
        //Check validation
        if (!this.validate())
            return;
        const arrNew: any = [...this.state.Registrants_arr];
        this.setState({ GuestIdMax: this.state.GuestIdMax + 1 })
        const newObj = { ID: this.state.GuestIdMax, Fname: this.state.GuestFName, Lname: this.state.GuestLName, Email: this.state.GuestEmail, Address1: this.state.GuestAddress1, City: this.state.GuestCity, State: this.state.GuestState, Address2: this.state.GuestAddress2, ZIP: this.state.GuestZipCode, RegistrantType: this.state.GuestType }
        arrNew.push(newObj);
        this.setState({ Registrants_arr: arrNew });
        this.Clear();
        this.setState({ Registrantmodal: false });
    }

    GridBind() {
        //
        this.GetArrayObj();
        return this.state.Registrants_arr.map((row: any, index) =>
            <tr>
                <td>{row.Fname}</td>
                <td>{row.Lname}</td>
                <td><a style={{ color: "#007bff", cursor: "pointer" }} onClick={() => this.FillForm(index)} title='Update Guest'> Edit</a> <a style={{ color: "#007bff", cursor: "pointer" }} onClick={() => { this.Delete(index) }} title='Delete Guest'>Remove</a></td>
            </tr>
        );
    }



    GetArrayObj() {
        let objFinal = '';
        let arr: any = [...this.state.Registrants_arr];
        //Prepare the string as (Fname,Lname,Email,Address1,Address2,City,State,Zip,RegistrantType|Fname,Lname,Email,Address1,Address2,City,State,Zip,RegistrantType)
        for (let i = 0; i < arr.length; i++) {
            objFinal += (arr[i].Fname + ',' + arr[i].Lname + ',' + arr[i].Email + ',' + arr[i].Address1 + ',' + arr[i].Address2 + ',' + arr[i].City + ',' + arr[i].State + ',' + arr[i].ZIP + ',' + arr[i].RegistrantType + '|');
        }
        this.props.onSelectGuests(objFinal);
    }


    FillForm(index: any) {

        if (index < 0)
            return;

        this.setState({ GuestRowIndex: index });
        let arr = [...this.state.Registrants_arr];
        let obj: any = arr[index];
        this.setState({ GuestFName: obj.Fname });
        this.setState({ GuestLName: obj.Lname });
        this.setState({ GuestEmail: obj.Email });
        this.setState({ GuestAddress1: obj.Address1 });
        this.setState({ GuestCity: obj.City });
        this.setState({ GuestZipCode: obj.ZIP });
        this.setState({ GuestAddress2: obj.Address2 });
        this.setState({ GuestState: obj.State });
        this.setState({ GuestType: obj.RegistrantType });
        this.setState(() => ({ AddTitle: { display: 'none' } }));
        this.setState(() => ({ UpdateTitle: { display: 'flex' } }));
        this.setState({ Registrantmodal: true });

    }

    Edit() {
        //Check validation
        if (!this.validate())
            return;

        let arrNew = [...this.state.Registrants_arr];
        let index = parseInt(this.state.GuestRowIndex, 10);

        if (index < 0)
            return;


        //Get current row obj from index
        let obj: any = arrNew[index];
        obj.Fname = this.state.GuestFName;
        obj.Lname = this.state.GuestLName;
        obj.Email = this.state.GuestEmail;
        obj.Address1 = this.state.GuestAddress1;
        obj.Address2 = this.state.GuestAddress2;
        obj.City = this.state.GuestCity;
        obj.State = this.state.GuestState;
        obj.ZIP = this.state.GuestZipCode;
        obj.RegistrantType = this.state.GuestType;
        this.setState({ Registrants_arr: arrNew });
        this.setState({ Registrantmodal: false });
        this.Clear();
    }

    Delete(index: any) {
        this.setState({ GuestRowIndex: index });
        this.setState({ DeleteModal: true });
    }

    DeleteGuest() {
        let arrNew = [...this.state.Registrants_arr];
        let index = parseInt(this.state.GuestRowIndex, 10);
        if (index > -1) {
            arrNew.splice(index, 1);
        }
        this.setState({ Registrants_arr: arrNew });
        this.setState({ DeleteModal: false });
    }

    validate() {
        let fname = this.state.GuestFName;
        let lname = this.state.GuestLName;
        let email = this.state.GuestEmail;
        let address1 = this.state.GuestAddress1;
        let city = this.state.GuestCity;
        let state = this.state.GuestState;
        let ZIP = this.state.GuestZipCode;
        let registrantType = this.state.GuestType;


        if (lname === '' || fname === '' || city === '' || address1 === '' || state === '' || ZIP === '' || registrantType === '') {
            this.setState({ lblResult: "Please enter all the required fields." });
            return false;
        }

        if (email !== '' && !this.validateEmail(email)) {
            this.setState({ lblResult: email + " is not valid email. Please enter valid email." });
            return false;
        }

        if (!this.validateZIP(ZIP)) {
            this.setState({ lblResult: ZIP + " is not valid ZIP Code. Please enter Only 5 digit." });
            return false;
        }
        return true;
    }

    validateEmail(email: any) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validateZIP(ZIP: any) {
        var re = /^((\d{5}(-|\s)\d{0,4})|(\d{5}))$/;
        return re.test(ZIP);
    }

    render() {        
        return (
            <React.Fragment>
                <div>
                    <span style={{ fontSize: "12px", color: "#666666" }}>Attending Guests<sup>&#8224;</sup>:</span>
                    <Button color='primary' onClick={this.ShowRegistrantModal}>Add Guest</Button>
                    <Modal isOpen={this.state.Registrantmodal} toggle={this.toggle}>
                        <ModalHeader style={this.state.AddTitle} id="AddTitle" toggle={this.CloseRegistrantModal}>Add Attending Guest Information</ModalHeader>
                        <ModalHeader style={this.state.UpdateTitle} id="EditTitle" toggle={this.CloseRegistrantModal}>Update Attending Guest Information</ModalHeader>
                        <ModalBody>
                            <div className="row">
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ color: "Red" }}>*</span><span style={{ fontSize: "12px", color: "#666666" }}>First Name:</span>
                                    <input type="text" value={this.state.GuestFName} onChange={(e) => { this.setState({ GuestFName: e.target.value }) }} name="firstname" style={{ width: "130px" }} required />
                                </div >
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ color: "Red" }}>*</span><span style={{ fontSize: "12px", color: "#666666" }}>Last Name:</span>
                                    <input value={this.state.GuestLName} type="text" onChange={(e) => { this.setState({ GuestLName: e.target.value }) }} name="lastname" style={{ width: "130px" }} required />
                                </div >
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ fontSize: "12px", color: "#666666" }}>Email:</span>
                                    <input value={this.state.GuestEmail} type="text" onChange={(e) => { this.setState({ GuestEmail: e.target.value }) }} name="email" style={{ width: "130px" }} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" />
                                </div >
                            </div>
                            <div className="row">
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ color: "Red" }}>*</span><span style={{ fontSize: "12px", color: "#666666" }}>Address1:</span>
                                    <input value={this.state.GuestAddress1} type="text" onChange={(e) => { this.setState({ GuestAddress1: e.target.value }) }} name="address1" style={{ width: "130px" }} required />
                                </div >
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ color: "Red" }}>*</span><span style={{ fontSize: "12px", color: "#666666" }}>City:</span>
                                    <input value={this.state.GuestCity} type="text" onChange={(e) => { this.setState({ GuestCity: e.target.value }) }} name="city" style={{ width: "130px" }} required />
                                </div >
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ color: "Red" }}>*</span><span style={{ fontSize: "12px", color: "#666666" }}>Zip Code:</span>
                                    <input value={this.state.GuestZipCode} type="text" onChange={(e) => { this.setState({ GuestZipCode: e.target.value }) }} name="zipcode" style={{ width: "130px" }} required />
                                </div >
                            </div>
                            <div className="row">
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ fontSize: "12px", color: "#666666" }}>Address2:</span>
                                    <input value={this.state.GuestAddress2} type="text" onChange={(e) => { this.setState({ GuestAddress2: e.target.value }) }} name="address2" style={{ width: "130px" }} />
                                </div >
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ color: "Red" }}>*</span><span style={{ fontSize: "12px", color: "#666666" }}>State:</span>
                                    <select data-val="true" value={this.state.GuestState} onChange={(e) => { this.setState({ GuestState: e.target.value }) }} style={{ width: "130px" }}>
                                        {this.state.ddlState.map((state: any) =>
                                            <option key={state.itemValue} value={state.itemValue}>{state.itemText}</option>
                                        )}
                                    </select>
                                </div >
                                < div style={{ float: "left", width: "26%", marginLeft: "20px" }}>
                                    <span style={{ color: "Red" }}>*</span><span style={{ fontSize: "12px", color: "#666666" }}>Guest is a:</span>
                                    <input value={this.state.GuestType} type="text" onChange={(e) => { this.setState({ GuestType: e.target.value }) }} name="guest" style={{ width: "130px" }} required />
                                </div >
                            </div>
                        </ModalBody>
                        <ModalFooter style={{ margin: "0px" }}>
                            <span style={{ color: "Red" }}>{this.state.lblResult}</span>
                            <Button color='primary' style={this.state.AddTitle} onClick={this.Add}>Add</Button>
                            <Button color='primary' style={this.state.UpdateTitle} onClick={this.Edit}>Update</Button>
                            <Button color='secondary' onClick={this.CloseRegistrantModal}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </div>
                <Modal isOpen={this.state.DeleteModal}>
                    <ModalHeader id="AddTitle" toggle={this.CloseDeleteModal}>Delete Attending Guest</ModalHeader>
                    <ModalBody>
                        <span>Are you sure you want to delete this guest?</span>
                    </ModalBody>
                    <ModalFooter>
                        <Button color='primary' onClick={this.DeleteGuest}>Ok</Button>
                        <Button color='secondary' onClick={this.CloseDeleteModal}>Close</Button>
                    </ModalFooter>
                </Modal>
                <div style={{ padding: "10px 0px" }}>
                    <div className="tblguest" style={{ float: "left" }}>
                        <table id="tblRegistrant" className="Registrants_Tbl">
                            <tbody>
                                <tr>
                                    <th style={{ width: "150px", backgroundColor: "#e2e2e2", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" }}> First Name</th>
                                    <th style={{ width: "150px", backgroundColor: "#e2e2e2", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" }}>Last Name</th>
                                    <th style={{ width: "150px", backgroundColor: "#e2e2e2", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" }}>Action</th>
                                </tr>
                                {this.state.Registrants_arr.length === 0 ?

                                    (< tr id="trNoRecords">
                                        <td colSpan={3} style={{ textAlign: "left", color: "#000", fontWeight: "normal", fontSize: "12px", padding: "2px 5px", border: "1px solid #ccc" }}>No Guests have been added</td>
                                    </tr>) :
                                    (this.GridBind())
                                }
                            </tbody>
                        </table>
                        <br />
                        <sup>&#8224;</sup>To accommodate your guests properly, please provide information here.
                    </div>
                </div>
            </React.Fragment >
        );
    }
}


